export type EmbeddingProfileId =
  | 'embeddinggemma'
  | 'snowflake-xs'

export type EmbeddingProfile = {
  id: EmbeddingProfileId
  label: string
  shortLabel: string
  modelId: string
  revision: string
  dimensions: number
  maxTokens: number
  approximateDownloadBytes: number
  dtype: 'q4' | 'q8'
  pooling: 'mean' | 'cls'
  queryPrefix: string
  documentPrefix: string
  license: string
  licenseUrl: string
  sourceUrl: string
  summary: string
}

export const EMBEDDING_PROFILES: Record<
  EmbeddingProfileId,
  EmbeddingProfile
> = {
  embeddinggemma: {
    id: 'embeddinggemma',
    label: 'EmbeddingGemma',
    shortLabel: 'Multilingual default',
    modelId: 'onnx-community/embeddinggemma-300m-ONNX',
    revision: '5090578d9565bb06545b4552f76e6bc2c93e4a66',
    dimensions: 256,
    maxTokens: 2048,
    approximateDownloadBytes: 218_730_000,
    dtype: 'q4',
    pooling: 'mean',
    queryPrefix: 'task: search result | query: ',
    documentPrefix: 'title: none | text: ',
    license: 'Gemma Terms',
    licenseUrl: 'https://ai.google.dev/gemma/terms',
    sourceUrl:
      'https://huggingface.co/onnx-community/embeddinggemma-300m-ONNX',
    summary:
      'Default. Multilingual and designed by Google for on-device use, but a large first download.',
  },
  'snowflake-xs': {
    id: 'snowflake-xs',
    label: 'Snowflake Arctic Embed XS',
    shortLabel: 'Lightweight fallback',
    modelId: 'Snowflake/snowflake-arctic-embed-xs',
    revision: 'd8c86521100d3556476a063fc2342036d45c106f',
    dimensions: 384,
    maxTokens: 512,
    approximateDownloadBytes: 23_690_000,
    dtype: 'q8',
    pooling: 'cls',
    queryPrefix:
      'Represent this sentence for searching relevant passages: ',
    documentPrefix: '',
    license: 'Apache-2.0',
    licenseUrl:
      'https://www.apache.org/licenses/LICENSE-2.0',
    sourceUrl:
      'https://huggingface.co/Snowflake/snowflake-arctic-embed-xs',
    summary:
      'About one tenth the download and English-first. Intended as the practical mobile fallback pending device benchmarks.',
  },
}

export const DEFAULT_EMBEDDING_PROFILE_ID: EmbeddingProfileId =
  'embeddinggemma'

export const ONNX_RUNTIME_APPROXIMATE_DOWNLOAD_BYTES =
  23 * 1024 * 1024

export function firstUseDownloadBytes(
  profile: EmbeddingProfile,
): number {
  return (
    profile.approximateDownloadBytes +
    ONNX_RUNTIME_APPROXIMATE_DOWNLOAD_BYTES
  )
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(bytes / 1024))} KiB`
  }
  const mebibytes = bytes / 1024 / 1024
  return `${Math.round(mebibytes)} MiB`
}
